import { Component, OnInit } from "@angular/core";
import { SpinnerService } from "@shared/services/spinner.service";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-spinner-component",
  templateUrl: "./global-spinner.component.html",
  styleUrls: ["./global-spinner.component.scss"]
})
export class GlobalSpinnerComponent implements OnInit {
  constructor(
    private spinnerService: SpinnerService,
    private spinner: NgxSpinnerService
  ) {
  }

  ngOnInit() {
    this.spinnerService.showSpinner.subscribe(status => {
      status ? this.spinner.show() : this.spinner.hide();
    });
  }
}
